import update from 'immutability-helper';
import ColorSchemes from 'mangools-commons/dist/constants/ColorSchemes';
import { REHYDRATE } from 'redux-persist/constants';
import hasPath from 'ramda/src/hasPath';

import ActionTypes from 'constants/ActionTypes';
import { DashboardTabs } from 'constants/Other';

const initialState = {
    colorScheme: ColorSchemes.LIGHT,
    dashboardTab: DashboardTabs.RESULTS,
    longerSerpLoadingNotificationVisible: false,
    newVersionNotificationShown: false,
    onlineStatus: true,
};

const miscReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UI_MISC_NEW_VERSION_NOTIFICATION_SHOWN_SET: {
            return update(state, {
                newVersionNotificationShown: {
                    $set: true,
                },
            });
        }

        case ActionTypes.UI_MISC_ONLINE_STATUS_SET: {
            return update(state, {
                onlineStatus: {
                    $set: action.payload.onlineStatus,
                },
            });
        }
        case ActionTypes.UI_MISC_DASHBOARD_TAB_SET: {
            return update(state, {
                dashboardTab: {
                    $set: action.payload,
                },
            });
        }
        case ActionTypes.UI_MISC_COLOR_SCHEME_SET: {
            return update(state, {
                colorScheme: { $set: action.payload },
            });
        }
        case ActionTypes.UI_MISC_LONGER_LOADING_NOTIFICATION_SHOW: {
            return update(state, {
                longerSerpLoadingNotificationVisible: { $set: true },
            });
        }
        case ActionTypes.UI_MISC_LONGER_LOADING_NOTIFICATION_HIDE: {
            return update(state, {
                longerSerpLoadingNotificationVisible: { $set: false },
            });
        }
        case REHYDRATE: {
            if (hasPath(['payload', 'ui', 'misc'], action)) {
                const { misc } = action.payload.ui;
                return update(state, {
                    colorScheme: {
                        $set: hasPath(['colorScheme'], misc) ? misc.colorScheme : initialState.colorScheme,
                    },
                });
            } else {
                return state;
            }
        }
        default: {
            return state;
        }
    }
};

export default miscReducer;
